import _ from 'lodash'

const filterOrderConfig: { [key: string]: string[] } = {
  'university-levels': ['beginner', 'intermediate', 'advanced'],
}

const researchCatOrder = {
  'Most Read': 0,
  Feature: 1,
  'Market Sizing': 2,
  Roundup: 3,
  DeFi: 4,
  Surveys: 5,
  Others: 6,
}

export const orderFilterItems = (
  type: string,
  filterItems: Array<any>,
  isUKIp: boolean,
  userRegion: string
) => {
  if (type === 'research') {
    return _.sortBy(filterItems, (c) => researchCatOrder[c.label])
  }

  if (type === 'university' && isUKIp) {
    return filterItems.filter(
      (item) => item.slug !== 'derivatives-university-en'
    )
  }

  if (type === 'product-news' && userRegion === 'FR') {
    return filterItems.filter(
      (item) => item.slug !== 'exchange-product-news-en'
    )
  }

  if (type === 'product-news' && userRegion === 'AE') {
    return filterItems.filter((item) => item.slug !== 'pay-product-news-en')
  }

  if (type in filterOrderConfig) {
    filterItems?.sort((a, b) => {
      return filterOrderConfig[type].indexOf(a.description) >
        filterOrderConfig[type].indexOf(b.description)
        ? 1
        : -1
    })
  }
  return filterItems
}
